import React from 'react';
import styles from './TitleSection.module.sass';

function TitleSection (props) {
    return (
      <div className={styles.titleSection}>
        <h2 className={styles.title}>{props.title}</h2>
      </div>
    )
};

export default TitleSection;
